function parseLinkValue(value) {
  const link = value.split('<->')[1];
  const text = value.split('<->')[0];
  return `<a href="${link}" rel="noopener noreferrer" target="_blank">${text}</a>`;
}

function getFieldSpan(key, value) {
  const tag = key.replace(/</u, '').replace(/>/u, '');
  const className = tag.split('.')[0];
  const tagKind = className.split('__')[1];
  let content = value;
  if (tagKind === 'post-link') {
    content = parseLinkValue(value);
  }
  return `<span class="${className}">${content}</span>`;
}

function replaceFields(fields, baseText, isTitle = false) {
  let resultText = baseText;

  for (const [key, value] of Object.entries(fields)) {
    resultText = resultText.split(key).join(isTitle ? value : getFieldSpan(key, value));
  }

  return resultText;
}

export function insightsHandler(insights) {
  if (insights.length === 0) {
    return [{ 'title': '', 'body': 'Não há insights para o período selecionado.' }];
  }

  return insights.map(insight => {
    insight.baseBody = replaceFields(insight.body_fields, insight.base_body);
    insight.baseTitle = replaceFields(insight.title_fields, insight.base_title, true);

    const { baseTitle: title, baseBody: body } = insight;
    return { title, body };
  }).slice(0, 6);
}
